export const PLACEHOLDER_IMAGE =
  "data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==";
export const BLUR_STYLES = {
  filter: "blur(10px)",
  transition: "80ms filter linear"
};
export const DEFAULT_TARGET_DENSITY = 1;
export const DEFAULT_DEVICE_PIXEL_RATIOS = [1, 2, 3, 4, 5];
